import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ReactComponent as Pencil } from '../../../../assets/icons/pencil.svg'
import { ReactComponent as Delete } from '../../../../assets/icons/trash.svg'
import {
    IEntity,
    INLUDataExample,
    useNLUDataStore,
} from '../../../../stores/nluDataStore'

import MessageForm from './MessageForm/MessageForm'
import MessageSection from './MessageSection/MessageSection'

import styles from './entity-section.module.scss'

interface IEntitySectionProps {
    example: INLUDataExample
    isAnyEntityEditing: boolean
    setIsAnyEntityEditing: React.Dispatch<React.SetStateAction<boolean>>
    examplesRef: React.RefObject<HTMLDivElement>
    allEntities: string[]
    deleteExample?: (id: string) => void | Promise<void>
    setEntities: (entities: IEntity[]) => void
}

function EntitySection(props: IEntitySectionProps) {
    const {
        example,
        isAnyEntityEditing,
        setIsAnyEntityEditing,
        examplesRef,
        allEntities,
        deleteExample,
        setEntities,
    } = props

    const { t } = useTranslation()

    const [, { setAddingExample }] = useNLUDataStore()

    const [isMessageEditing, setIsMessageEditing] = useState(false)

    return (
        <div className={styles.entitySection}>
            {isMessageEditing ? (
                <MessageForm
                    setIsMessageEditing={setIsMessageEditing}
                    example={example}
                />
            ) : (
                <MessageSection
                    example={example}
                    isAnyEntityEditing={isAnyEntityEditing}
                    setIsAnyEntityEditing={setIsAnyEntityEditing}
                    examplesRef={examplesRef}
                    allEntities={allEntities}
                    setEntities={setEntities}
                    startEditingCallback={() => setAddingExample(false)}
                />
            )}
            <div className={styles.entitySection__buttons}>
                <button
                    className={styles.entitySection__btn}
                    onClick={() => setIsMessageEditing((prev) => !prev)}
                >
                    <Pencil
                        className={styles.entitySection__btnIcon}
                        alt={t('edit')}
                    />
                </button>
                {deleteExample ? (
                    <button
                        className={styles.entitySection__btn}
                        onClick={() => deleteExample(example._id)}
                    >
                        <Delete
                            className={styles.entitySection__btnIcon}
                            alt="Delete"
                        />
                    </button>
                ) : null}
            </div>
        </div>
    )
}

export default EntitySection
